import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DonationFlagsService {
  private baseUrl = '/api/donation-flags';

  constructor(private http: HttpClient) {}

  getFlags(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}`);
  }

  saveFlag(flag: any): Observable<any> {
    return flag.donationsFlagId
      ? this.http.put(`${this.baseUrl}/${flag.donationsFlagId}`, flag) // Update existing flag
      : this.http.post(`${this.baseUrl}`, flag); // Create new flag
  }

  deleteFlag(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
